"use client"

import { useState } from "react"

export default function MembershipTabs() {
  const [activeTab, setActiveTab] = useState("adult")

  const adultPlans = [
    {
      name: "Drop In Dodger",
      price: "€12.50",
      period: "per session",
      features: ["Single session access", "Equipment included", "All skill levels welcome"],
      popular: false,
    },
    {
      name: "Weekly Warrior",
      price: "€40.00",
      period: "per month",
      features: ["4 sessions per month", "Priority booking", "Equipment included", "Community access"],
      popular: true,
    },
  ]

  const youthPlans = [
    {
      name: "Half Season",
      price: "€185",
      period: "half season",
      features: ["6 months access", "Youth coaching", "Equipment included", "Tournament entry"],
      popular: false,
    },
    {
      name: "Full Season",
      price: "€325",
      period: "full season",
      features: ["12 months access", "Youth coaching", "Equipment included", "Tournament entry", "Special events"],
      popular: true,
    },
  ]

  return (
    <div className="w-full">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold mb-4">Choose Your Plan</h2>
        <p className="text-xl text-gray-600">Find the perfect membership for your dodgeball journey</p>
      </div>

      {/* Tabs */}
      <div className="flex justify-center mb-12">
        <div className="bg-white rounded-full p-2 shadow-lg">
          <button
            className={`px-8 py-3 rounded-full font-medium transition-colors ${
              activeTab === "adult" ? "bg-[#E67E22] text-white" : "text-gray-600 hover:text-[#E67E22]"
            }`}
            onClick={() => setActiveTab("adult")}
          >
            Adult Plans
          </button>
          <button
            className={`px-8 py-3 rounded-full font-medium transition-colors ${
              activeTab === "youth" ? "bg-[#E67E22] text-white" : "text-gray-600 hover:text-[#E67E22]"
            }`}
            onClick={() => setActiveTab("youth")}
          >
            Youth Plans
          </button>
        </div>
      </div>

      {/* Plans */}
      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        {(activeTab === "adult" ? adultPlans : youthPlans).map((plan, index) => (
          <div
            key={index}
            className={`bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-shadow relative reveal ${
              plan.popular ? "ring-2 ring-[#E67E22]" : ""
            }`}
          >
            {plan.popular && (
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-[#E67E22] text-white px-4 py-1 rounded-full text-sm font-medium">Most Popular</span>
              </div>
            )}
            <h3 className="text-2xl font-bold text-black mb-2">{plan.name}</h3>
            <div className="mb-6">
              <span className="text-4xl font-bold text-[#E67E22]">{plan.price}</span>
              <span className="text-gray-600 ml-2">{plan.period}</span>
            </div>
            <ul className="space-y-3 mb-8">
              {plan.features.map((feature, idx) => (
                <li key={idx} className="flex items-center gap-3">
                  <div className="w-5 h-5 bg-[#E67E22]/20 rounded-full flex items-center justify-center">
                    <div className="w-2 h-2 bg-[#E67E22] rounded-full" />
                  </div>
                  <span className="text-gray-700">{feature}</span>
                </li>
              ))}
            </ul>
            <button className="w-full bg-[#E67E22] text-white py-3 rounded-full hover:bg-[#D35400] transition-colors font-medium">
              Choose Plan
            </button>
            <p className="text-xs text-gray-500 text-center mt-3">Secure payments powered by Stripe</p>
          </div>
        ))}
      </div>
    </div>
  )
}
